/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PuzzlePieceMinusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABEUlEQVR4nO2VS04CQRCGWxPZ6AYu4GnYCPWApFIlcT2JmBBuMFsIQe8E4Sg+okaXRjeYNj4CdAMD9MKEP6nN5O//q+rM1Di3V1GJSAlZ+0B6h2zTryK7z/P8MGA/QNaHHx+w3iJbz2dEAd7wG8x/JSKVQDOVkNdnRAHfXSweatjVQjMN64S8PmPZBKGOpkj6BqyXInJSrV4c1+m87Z/F/MUBXKyC4bVaq5wEICIlIBsC62sSALLe7CoYI4CntACyx6QAYL1OCsiy7AjZBsj68i9eUyB93vhDA7J3vyJ8M24TrQHoum0UXXY8u1WBbbLyukjHa69rnAP4wyunZRtFfjjWC00CpB9nzdbpVle0l5vTJ5RUQlYyZtxZAAAAAElFTkSuQmCC)
 */
export const PuzzlePieceMinusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16 4a3 3 0 1 1-5.98-.31c.03-.35-.21-.69-.56-.69H7a3 3 0 0 0-3 3v2.5c0 .28-.23.5-.5.54a3 3 0 0 0 0 5.92c.27.04.5.26.5.54V18a3 3 0 0 0 3 3h4.65c.43 0 .69-.55.54-.95A3 3 0 0 1 15 16h6.5a.5.5 0 0 0 .5-.5V6a3 3 0 0 0-3-3h-2.46c-.35 0-.6.34-.56.69L16 4Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15 18a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8Z"
        className={colorClass}
      />
    </svg>
  );
};
